module.exports = __webpack_public_path__ + "img/bg_yaoke_certificate.f6c8d0a6.jpg";